import { PAYMENT } from "../constants";
import { instance } from "../../axios";
import { getSubscriptionAction } from "../actions/subscription";
import { store } from "../../store";

let getPaymentsAction = () => {
  return (dispatch) => {
    dispatch({
      type: PAYMENT.GET_PAYMENTS,
    });
    const state = store.getState().payment;
    const limit = state.limit || 20;
    const offset = state.offset || 0;
    const now = new Date();
    const month = state.month || now.getMonth() + 1;
    const year = state.year || now.getFullYear();
    instance
      .get(`/payment?limit=${limit}&offset=${offset}&month=${month}&year=${year}&moduleFilter=${encodeURI(state.moduleFilter || "")}`)
      .then((results) => {
        dispatch({
          type: PAYMENT.GET_PAYMENTS_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: PAYMENT.GET_PAYMENTS_FAILURE,
          payload: error,
        });
      });
  };
};

let setPaymentOffset = (offset) => {
  return (dispatch) => {
    dispatch({
      type: PAYMENT.SET_OFFSET,
      payload: offset,
    });
    dispatch(getPaymentsAction());
  };
};

let setPaymentMonthYear = (month, year) => {
  return (dispatch) => {
    dispatch({
      type: PAYMENT.SET_MONTH_YEAR,
      payload: { month, year },
    });
    dispatch(getPaymentsAction());
  };
};

let createPaymentAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: PAYMENT.CREATE_PAYMENT,
    });
    instance
      .post("/payment", body)
      .then((results) => {
        dispatch({
          type: PAYMENT.CREATE_PAYMENT_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionAction(body.subscription_id));
      })
      .catch((error) => {
        dispatch({
          type: PAYMENT.CREATE_PAYMENT_FAILURE,
          payload: error,
        });
      });
  };
};

let deletePaymentAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: PAYMENT.DELETE_PAYMENT,
    });
    instance
      .delete("/payment/" + id)
      .then((results) => {
        dispatch({
          type: PAYMENT.DELETE_PAYMENT_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionAction(results.data.subscription_id));
      })
      .catch((error) => {
        dispatch({
          type: PAYMENT.DELETE_PAYMENT_FAILURE,
          payload: error,
        });
      });
  };
};

let setPaymentModuleFilter = (value) => {
  return (dispatch) => {
    dispatch({
      type: PAYMENT.SET_MODULE_FILTER,
      payload: value,
    });
    dispatch(getPaymentsAction());
  };
};

export {
  getPaymentsAction,
  createPaymentAction,
  deletePaymentAction,
  setPaymentOffset,
  setPaymentMonthYear,
  setPaymentModuleFilter,
};
